const MAP = {
  active: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  verified: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  approved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  paid: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  published: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  resolved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  ok: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  configured: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  available: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  pending: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  pending_review: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  pending_approval: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  submitted: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  requested: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  review: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  verification_pending: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  created: "bg-slate-500/10 text-slate-400 border-slate-500/20",
  draft: "bg-slate-500/10 text-slate-400 border-slate-500/20",
  scheduled: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  processing: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  in_progress: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  open: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  waiting_for_partner: "bg-purple-500/10 text-purple-400 border-purple-500/20",
  test: "bg-purple-500/10 text-purple-400 border-purple-500/20",
  sandbox: "bg-purple-500/10 text-purple-400 border-purple-500/20",
  mock: "bg-purple-500/10 text-purple-400 border-purple-500/20",
  on_hold: "bg-orange-500/10 text-orange-400 border-orange-500/20",
  paused: "bg-orange-500/10 text-orange-400 border-orange-500/20",
  restricted: "bg-orange-500/10 text-orange-400 border-orange-500/20",
  escalated: "bg-orange-500/10 text-orange-400 border-orange-500/20",
  failed: "bg-red-500/10 text-red-400 border-red-500/20",
  rejected: "bg-red-500/10 text-red-400 border-red-500/20",
  suspended: "bg-red-500/10 text-red-400 border-red-500/20",
  reversed: "bg-red-500/10 text-red-400 border-red-500/20",
  refunded: "bg-red-500/10 text-red-400 border-red-500/20",
  cancelled: "bg-slate-800 text-slate-400 border-slate-700",
  closed: "bg-slate-800 text-slate-400 border-slate-700",
  archived: "bg-slate-800 text-slate-400 border-slate-700",
  not_configured: "bg-slate-800 text-slate-400 border-slate-700",
  not_submitted: "bg-slate-800 text-slate-400 border-slate-700",
};

export function StatusBadge({ status, testid }) {
  const s = String(status ?? "—");
  return (
    <span
      data-testid={testid || `status-${s}`}
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-3 py-1 text-[11px] font-bold capitalize tracking-wide ${MAP[s] || "bg-slate-800 text-slate-400 border-slate-700"}`}
    >
      {s.replace(/_/g, " ")}
    </span>
  );
}

export const Card = ({ className = "", children, ...p }) => (
  <div className={`glass rounded-3xl p-6 shadow-xl ${className}`} {...p}>
    {children}
  </div>
);

export function Stat({ label, value, tag, tone = "navy", testid, hint }) {
  const tones = { navy: "text-white", green: "text-emerald-400", blue: "text-blue-400", purple: "text-purple-400", amber: "text-[#D4AF37]", red: "text-red-400" };
  return (
    <div className="glass rounded-2xl p-5 transition-transform hover:-translate-y-1" data-testid={testid}>
      <div className="flex items-start justify-between gap-2">
        <p className="text-[11px] font-bold uppercase tracking-widest text-slate-500">{label}</p>
        {tag && <span className="rounded-md bg-white/5 px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-slate-400">{tag}</span>}
      </div>
      <p className={`mt-3 text-2xl font-black tabular-nums ${tones[tone]}`}>{value}</p>
      {hint && <p className="mt-1 text-[10px] text-slate-500">{hint}</p>}
    </div>
  );
}

export const PageTitle = ({ title, sub, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="text-3xl font-black tracking-tight text-white sm:text-4xl" data-testid="page-title">{title}</h1>
      {sub && <p className="mt-2 text-sm text-slate-400">{sub}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Empty = ({ text, testid = "empty-state" }) => (
  <div className="glass rounded-3xl border-dashed border-white/10 p-12 text-center text-sm text-slate-400" data-testid={testid}>
    {text}
  </div>
);

export const Notice = ({ tone = "amber", children, testid }) => {
  const t = {
    amber: "border-[#D4AF37]/20 bg-[#D4AF37]/10 text-[#D4AF37]",
    blue: "border-blue-500/20 bg-blue-500/10 text-blue-400",
    purple: "border-purple-500/20 bg-purple-500/10 text-purple-400",
    red: "border-red-500/20 bg-red-500/10 text-red-400",
    green: "border-emerald-500/20 bg-emerald-500/10 text-emerald-400",
  };
  return (
    <div className={`rounded-2xl border px-5 py-4 text-sm font-medium ${t[tone]}`} data-testid={testid}>
      {children}
    </div>
  );
};

export function Table({ cols, rows, testid = "data-table", empty = "No records" }) {
  if (!rows?.length) return <Empty text={empty} />;
  return (
    <div className="glass overflow-hidden rounded-3xl" data-testid={testid}>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[640px] text-sm">
          <thead className="bg-white/5 text-left text-[10px] font-bold uppercase tracking-widest text-slate-500">
            <tr>{cols.map((c) => <th key={c.k} className="whitespace-nowrap px-5 py-4">{c.l}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {rows.map((r, i) => (
              <tr key={r.id || i} className="transition-colors hover:bg-white/[0.02]" data-testid={`row-${r.id || i}`}>
                {cols.map((c) => <td key={c.k} className="px-5 py-4 align-top text-slate-300">{c.r ? c.r(r) : r[c.k] ?? "—"}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
